module.exports = __webpack_public_path__ + "static/media/photography-2-3.00c1103b.jpg";